import { StrictLocalizeFunction } from "@faire/web/common/localization";

export interface IProductSpotlightGroup {
  image: string;
  title: string;
  eventKey: string;
  subtitle: string;
}

export interface IProductSpotlightGroup {
  image: string;
  title: string;
  eventKey: string;
  subtitle: string;
}

export const getProductSpotlightCards = (
  strictLocalize: StrictLocalizeFunction,
  isNorthAmerican: boolean
): IProductSpotlightGroup[] => {
  return [
    {
      image: isNorthAmerican
        ? "https://cdn.faire.com/fastly/03f9220e21dcd4ec956cf31c99e6d9c5f67efea27d5e13923d1f291d740a0624.png"
        : "https://cdn.faire.com/fastly/7e3d1585d334c378d15213c863989fa49bca15d269ca183d247e8f1fcb81d189.png",
      title: strictLocalize({
        defaultMessage: "Online store",
        description: { text: "Benefit offered to brands by Faire" },
      }),
      eventKey: "online-store",
      subtitle: strictLocalize({
        defaultMessage: "Get a free ecommerce storefront for your products.",
      }),
    },
    {
      image: isNorthAmerican
        ? "https://cdn.faire.com/fastly/2d754567156c6bfa41d80a8a224e51c05466670f4a78f7f5d29d947aab06dec7.png"
        : "https://cdn.faire.com/fastly/51719a765a524d11b4fb97d0f9f965f4821d7585a41b84f3b029e1fb4c2fc87f.png",
      title: strictLocalize({
        defaultMessage: "Easy order fulfillment",
        description: { text: "Benefit offered to brands by Faire" },
      }),
      eventKey: "easy-order-fulfillment",
      subtitle: strictLocalize({
        defaultMessage: "Fulfill new orders and create invoices ",
      }),
    },
    {
      image: isNorthAmerican
        ? "https://cdn.faire.com/fastly/6249699380b12c0acfc10917e64ec4f919a85f0321c44cee7bac3d0abe4af6e0.png"
        : "https://cdn.faire.com/fastly/8793f3abb0991a7656d020e4f8af162c33e79d2b5d8d9f214ff0248349a47670.png",
      title: strictLocalize({
        defaultMessage: "Customer management",
        description: { text: "Benefit offered to brands by Faire" },
      }),
      eventKey: "customer-management",
      subtitle: strictLocalize({
        defaultMessage: "Keep track of all your customers in one place",
      }),
    },
    {
      image: isNorthAmerican
        ? "https://cdn.faire.com/fastly/c619953b1d10ad828fa410cf894f1df70136df09441726de370d0f3f042ceb1a.png"
        : "https://cdn.faire.com/fastly/a614ea7ef1b263c2fdbff8ecc7dc45a2b4122b546f745125b4562aac920c8e3b.png",
      title: strictLocalize({
        defaultMessage: "Marketing campaigns",
        description: { text: "Benefit offered to brands by Faire" },
      }),
      eventKey: "marketing-campaigns",
      subtitle: strictLocalize({
        defaultMessage: "Promote your brand with rich content emails",
      }),
    },
    {
      image: isNorthAmerican
        ? "https://cdn.faire.com/fastly/36573cc8032113ef16577d580d89f7c555ff34890adb2b1ce030a3cf144bc5cf.png"
        : "https://cdn.faire.com/fastly/ba2ee160786342043966eb5541213812104e5a96029516f7243652e56df4bcad.png",
      title: strictLocalize({
        defaultMessage: "Built–in analytics",
        description: { text: "Benefit offered to brands by Faire" },
      }),
      eventKey: "built–in-analytics",
      subtitle: strictLocalize({
        defaultMessage: "Learn insights about how your business is doing",
      }),
    },
    {
      image: isNorthAmerican
        ? "https://cdn.faire.com/fastly/a039866d012d2b5910cbbe07f3dcebf177ab2ee7177aabcf94b18ed4d7a3b751.png"
        : "https://cdn.faire.com/fastly/0e34ec7edb337d4534ef29abfb015fe3aa67da07c2f67012d40a51cd775be90e.png",
      title: strictLocalize({
        defaultMessage: "Messaging system",
        description: { text: "Benefit offered to brands by Faire" },
      }),
      eventKey: "messaging-system",
      subtitle: strictLocalize({
        defaultMessage:
          "Connect with your retailers through the Faire platform",
      }),
    },
  ];
};
